var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBidscaleLogoAndText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 505 792 125",
    style: {
      enableBackground: "new 0 0 792 1224"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#013845;}\r\n\t.st1{fill:#26AA93;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M324.1,575.4c0.4-17.4,1.2-16.3-6.3-17.3l-4.5-0.4v-4.4c11.8-2.7,17.1-6.3,24.6-9.9l1.1,1.1 c-0.4,7.4-0.6,20.3-0.6,27.3v18.3c0,17.2,0.4,17.5,7.1,18.7l3.8,0.9v4.4c-11.6-0.9-24.1-0.9-36.1,0v-4.4l4.1-0.9 c6.2-1.1,6.7-1.4,6.7-18.7V575.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.6,616.6c0.2-7,0.2-7,0.2-11.8c-5.3,7.2-11.9,10.9-21.2,10.9c-17.8,0-29.8-14.2-29.8-34.2 c0-24.4,18.7-37.8,36.4-37.8c5.8,0,10.4,1.4,14.1,3.4v-2.2c0.1-16.4,1.5-18.1-6.4-18.2l-4.2-0.2l0-4.7c11.7-3.7,15.3-5.2,24.5-10.6 l1.1,1.3c-0.4,7.8-0.6,19.1-0.6,26.5v49.1c0,14.6,0.6,16.6,5.7,17l5.1,0.4v4.4C425.8,610.9,415.9,613.9,408.6,616.6z M395.4,606.2 c5.3,0,9.2-1.8,13.1-6.1c-0.1-1.7-0.1-3.6-0.1-5.4v-29.4c0-10.2-6.8-15.8-16.2-15.8c-11.1,0-19.6,8.9-19.6,26.1 C372.5,594.6,381.5,606.2,395.4,606.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.8,600.4c0-17.9-38.5-13.2-38.5-37.3c0-10.7,8.9-19.3,24.7-19.3c8.7,0,15.5,2.1,21.6,5.4 c0,5.8,0.3,10.8,0.9,17.2h-3.6c-7.2-12.4-12.5-17-20.9-17c-6.4,0-9.7,4.1-9.7,9.1c0,16.9,38.3,11.8,38.3,36.5 c0,12.2-11.4,20.9-27,20.9c-9.7,0-19-2.7-24-6c0.3-5.5,0.4-11.2,0.3-17.6h3.1c6,14.2,14.3,18.2,22.7,18.2 C477.8,610.4,481.8,606.1,481.8,600.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M518.6,570.7c0,21,10.5,33.2,26,33.2c6.5,0,12.6-2.7,18-9.2l2.3,1.8c-6.4,12.9-16,19.2-27.3,19.2 c-19,0-32.8-14.6-32.8-35.2c0-22.7,15.6-36.8,32.8-36.8c14.6,0,24.4,9.2,24.4,17.6c0,5.1-3.3,7.8-8.1,8.4l-2.3-0.9 c-3.7-12.4-8.7-19.2-17.9-19.2C525,549.7,518.6,557.1,518.6,570.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M624.1,615.8c-5.7,0-9.8-3.3-9.8-10.1v-0.4c-4.5,6.4-10.1,10.5-20.6,10.5c-12.2,0-20.8-7.3-20.3-18.2 c0.5-11.8,6.1-15.4,22.4-20.7l17.9-6.1v1.2c0-13.3-4.7-22.3-13.9-22.3c-7.7,0-11.6,6.2-10.5,20.2l-2.4,0.7c-5.4-0.1-9.7-1.7-9.7-6.7 c0-9.2,14.6-20.2,28.5-20.2c15.3,0,22.3,8.5,22.3,25v31.5c0,5,0.9,6.5,3.8,6.5c2.4,0,4.7-1,7.1-3.3l2,2.1 C635.7,612.6,630.3,615.8,624.1,615.8z M613.7,601.6v-25.5l-10.4,4.7c-15.9,7.6-15.6,11.4-15.9,13.3c-1.2,7.5,5.5,12.9,13.3,12.9 C605.6,607,610.3,605.4,613.7,601.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M679.5,608.8l4.1,0.9v4.4c-11.8-0.9-24-0.7-36.1,0v-4.4l4.1-0.9c6.4-1.1,6.8-1.8,6.8-18.5v-48.3 c0.1-14.9,1.8-14.2-6.8-14.5h-4.1v-5.4c9.9-3,14.2-4.2,24.6-10.9l1.3,1.3c-0.3,8.4-0.5,21.2-0.6,29v48.9 C672.8,607,673.1,607.7,679.5,608.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M724.4,613.7c-19.9,0-32.9-15.3-32.9-35.2c0-22.7,15.6-36.8,32.5-36.8c17.6,0,26.8,13.6,26.8,27.4 c0,1.4,0,3.7-0.3,5.7h-45.2c1.7,16.3,11.4,27,25.3,27c7.8,0,15.1-3.4,20.2-8.7l2.4,1.8C746.4,608.1,736.4,613.7,724.4,613.7z  M705,570.1l32-2c-1.4-13.8-7.7-20.3-16.6-20.3c-8.1,0-15.3,6.1-15.3,21.7V570.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 330.7,
    cy: 521.3,
    r: 9.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.3,618.4c-11,0-22.9-0.7-34,0v-4.5l5.2-1c5.4-0.9,5.8-2.9,5.8-20V545c0-17.1-0.4-19.2-5.8-20.1l-5.2-0.9 v-4.6c10.9,0.6,19.8,0,30.7,0c22.6,0,40.1,5.9,40.1,23.4c0,9.8-5.1,18.1-21,22.1c18.1,2.5,27.2,11.4,27.2,24.2 C302.3,606.5,287.4,618.4,259.3,618.4z M279.7,544.4c0-12.9-9.5-19.2-27.5-19.2V564h5.9C270.8,564,279.7,557.3,279.7,544.4z  M285.5,590.9c0-13.7-10.8-21.6-26.5-21.6h-6.8v30.1c0,10.6,2.9,13.5,11.7,13.5C277.7,612.9,285.5,605.1,285.5,590.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.7,
    y: 504.6,
    className: "st1",
    width: 127.1,
    height: 127.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132,576.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.4,587.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.2,565.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103,587"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103,575.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.7,563.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.2,576.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "128,556.1 128,555.9 128,555.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.8,552.4C127.8,552.4,127.8,552.4,127.8,552.4l-0.6-8.2c0,0,0,0,0,0L127.8,552.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143.7,543.4c0,0-6.6-1.1-13.2-1.2l3.2,47.1c0,0-7,0-14.7,3c-3.7,1.4-6.8,3.6-8.7,5.1c3.6-1.4,10-3.3,17.6-4 c12.2-1.1,19.3,1.9,19.3,1.9L143.7,543.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.7,567.2c-8.4,1.3-18.1,5.9-23.3,11.4l0.4,6.6c5.8-4.9,14.8-9.9,23.3-10.6L128.7,567.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.5,589.4c5.6-2.5,9.6-3.4,13.5-3.7l-0.6-7.4c-8.8,0.7-18.1,5.9-23.3,11l0.5,6.7 C109.2,593.4,112,591.4,116.5,589.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.4,531.7c0,0-6.4,1.2-13.8,6c-7.5,4.8-9.2,8.9-9.2,8.9l0,0.2l0.4,5.7c3.5-3.2,8.3-7.1,15.3-9.7 c2.4-0.9,5.1-1.7,8-2.4L126.4,531.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.2,544.2c-12.1,2.8-18.9,8.3-23.2,12.6l0.5,7.1c6.7-5.9,15.4-10,23.3-11.5L127.2,544.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128,555.9c-8.9,1.7-17,6.3-23.2,12.2l0.4,6.5c7-5.8,14.8-9.5,23.3-10.9L128,555.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.5,597.2l-0.5-7.7c-8-1.4-23.4-2.6-40.1,4.1l0.6,8.5C77.2,596.5,91.4,594.8,103.5,597.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.8,586.2l-0.5-7.4c-12-2.5-29.2-1-40.2,3.5l0.5,7.9C78.4,584.2,92.9,584.6,102.8,586.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.1,575.5l-1.9-28.5c0,0-9.5-1.7-20.3-0.8c-11,0.9-19.9,4.2-19.9,4.2l1.9,28.5 C73.3,574.6,89.8,573.1,102.1,575.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidscaleLogoAndText);
export default __webpack_public_path__ + "static/media/bidscaleLogoAndText.794fa51bd29a94ee0b6b664dd316b3fe.svg";
export { ForwardRef as ReactComponent };